class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();

    this.trigger = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.updateDrawerPosition = this.updateDrawerPosition.bind(this);
  }

  connectedCallback() {
    if (this.isConnectedAndReady) return;

    this.isConnectedAndReady = true;
    this.panel = this.querySelector('[role="dialog"]');
    this.closeButton = this.querySelector('.size-guide-drawer__close');

    document.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('keydown', this.handleKeydown);

    if (this.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.trigger);
    }

    this.isConnectedAndReady = false;
  }

  handleClick(event) {
    const openTrigger = event.target.closest('[data-size-guide-trigger]');
    if (openTrigger) {
      event.preventDefault();
      this.open(openTrigger);
      return;
    }

    if (this.classList.contains('active') && event.target.closest('[data-size-guide-close]')) {
      this.close();
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('active')) this.close();
  }

  open(trigger) {
    if (!this.panel || this.classList.contains('active')) return;

    this.trigger = trigger;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.setAttribute('aria-hidden', 'false');
    this.updateDrawerPosition();
    window.addEventListener('resize', this.updateDrawerPosition);
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
    trapFocus(this.panel, this.closeButton || this.panel);
  }

  close() {
    if (!this.classList.contains('active')) return;

    this.classList.remove('active');
    this.setAttribute('aria-hidden', 'true');
    window.removeEventListener('resize', this.updateDrawerPosition);
    document.body.classList.remove('overflow-hidden');

    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'false');
    removeTrapFocus(this.trigger);
  }

  updateDrawerPosition() {
    const headerWrapper = document.querySelector('.section-header .header-wrapper');
    const top = Math.max(0, headerWrapper?.getBoundingClientRect().top || 0);
    this.style.setProperty('--size-guide-drawer-top-position', `${Math.round(top)}px`);
  }
}

if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
